<template>
    <div class="client-single client-view-single">
        <div class="m-content">
            <div class="row">
                <div class="col-12 col-lg-6">

                    <div class="m-portlet m-portlet--mobile">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        Anfragen
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body">

                            <table class="table table-striped- table-bordered table-hover table-checkable" id="inquiry-table">
                                <thead>
                                <tr role="row">
                                    <th class="sorting_asc">Auftrags Nr.</th>
                                    <th class="sorting">Erstellt am</th>
                                    <th class="sorting">Aktueller Status</th>
                                    <th class="sorting">Projekt</th>
                                    <th class="sorting">Aktionen</th>
                                </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(project, key) in projectArr">
                                        <td>{{ project.client_project_count }}</td>
                                        <td>{{ project.created }}</td>
                                        <td>
                                            <span v-if="project.current_status_id < 2" class="m-badge  m-badge--danger m-badge--wide">Briefing erstellen</span>
                                            <span v-else-if="project.current_status_id == 3" class="m-badge  m-badge--brand m-badge--wide">Fotografie</span>
                                            <span v-else-if="project.current_status_id == 4" class="m-badge  m-badge--metal m-badge--wide">Bildbearbeitung</span>
                                            <span v-else-if="project.current_status_id < 6" class="m-badge  m-badge--info m-badge--wide">Kontrolle</span>
                                            <span v-else class="m-badge  m-badge--default m-badge--wide">Abgeschlossen</span>
                                        </td>
                                        <td>{{ project.name }}</td>
                                        <td><a :href="'projekt-' + project.id" class="m-badge  m-badge--warning m-badge--wide">Details</a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-lg-6">

                    <!--Begin::Portlet-->
                    <div class="m-portlet  m-portlet--full-height ">
                        <div class="m-portlet__head">
                            <div class="m-portlet__head-caption">
                                <div class="m-portlet__head-title">
                                    <h3 class="m-portlet__head-text">
                                        Verlauf Ihrer Projekte
                                    </h3>
                                </div>
                            </div>
                        </div>
                        <div class="m-portlet__body">
                            <timeline :timeline-arr="timelineArr"></timeline>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>
<script>

    import Timeline from "./client-view/Timeline";
    export default {
        name: 'client-view-single',
        props: {
            timelineArr: Object,
            projectArr: Object
        },
        components: {
            Timeline
        },
        data() {
            return {
                editClientDataToggle: false,
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        },
        mounted() {

        },
        watch: {

        },
        methods: {

        }
    }
</script>
